module.exports = __webpack_public_path__ + "img/chrome.5df57a7c.svg";